import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input()
  url?: string | (string | undefined | null)[];

  @Input()
  text!: string;

  @Input()
  alignment: 'center' | 'left' = 'center'

  @Input()
  buttonType: 'submit' | 'button' = 'submit';

  @Input()
  disabled = false;

  @Input()
  secondary = false;

  @Input()
  icon?: IconDefinition;
}
